import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const NAV_ITEMS = [
  { path: '/',         icon: 'auto_awesome',   label: 'Feed'    },
  { path: '/reels',   icon: 'play_circle',    label: 'Reels'   },
  { path: null,       icon: 'add_circle',     label: 'Create', isCreate: true },
  { path: '/salon',   icon: 'groups',         label: 'Salon'   },
  { path: '/curation',icon: 'account_circle', label: 'Profile' },
];

const MobileNav = ({ onCreate }) => {
  const navigate  = useNavigate();
  const { pathname } = useLocation();
  const { user } = useAuth();
  const isReels = pathname === '/reels';

  // Hide nav inside full-screen Reels
  if (isReels) return null;

  const isAdmin = user?.email?.toLowerCase().includes('admin');
  const items = [...NAV_ITEMS];
  
  // If Admin, replace Salon with Admin tools in the quick nav (or just append it)
  // We'll append it, but we only have so much space, so let's swap Salon for Admin for Admins
  if (isAdmin) {
    const salonIndex = items.findIndex(i => i.path === '/salon');
    if (salonIndex !== -1) {
      items[salonIndex] = { path: '/admin', icon: 'admin_panel_settings', label: 'Admin' };
    }
  }

  return (
    <>
      {/* Safe-area spacer so content isn't hidden under the bar */}
      <div className="md:hidden" style={{ height: '72px' }} aria-hidden="true" />

      <nav
        className="md:hidden fixed bottom-0 left-0 right-0 z-[90]"
        style={{
          background: 'rgba(9,9,11,0.92)',
          backdropFilter: 'blur(32px)',
          WebkitBackdropFilter: 'blur(32px)',
          borderTop: '0.5px solid rgba(255,255,255,0.08)',
          paddingBottom: 'env(safe-area-inset-bottom, 0px)',
        }}
      >
        <div className="flex items-center justify-around px-2 h-[56px]">
          {items.map((item) => {
            if (item.isCreate) {
              return (
                <button
                  key="create"
                  id="mobile-create-btn"
                  onClick={onCreate}
                  className="flex flex-col items-center justify-center relative"
                  style={{ minWidth: '52px' }}
                >
                  <div
                    className="w-12 h-12 rounded-full flex items-center justify-center transition-transform active:scale-90"
                    style={{
                      background: 'linear-gradient(135deg,#c9a96e,#e8c98a)',
                      boxShadow: '0 0 20px rgba(201,169,110,0.4)',
                    }}
                  >
                    <span className="material-symbols-outlined text-black text-[26px]" style={{ fontVariationSettings: "'FILL' 1" }}>
                      add
                    </span>
                  </div>
                </button>
              );
            }

            const active = pathname === item.path || (item.path === '/' && pathname === '/news-feed');

            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className="flex flex-col items-center justify-center gap-0.5 relative transition-all duration-200 active:scale-90"
                style={{ minWidth: '48px', minHeight: '48px' }}
              >
                <span
                  className="material-symbols-outlined transition-all duration-200"
                  style={{
                    fontSize: '24px',
                    color: active ? '#c9a96e' : 'rgba(255,255,255,0.4)',
                    fontVariationSettings: active ? "'FILL' 1" : "'FILL' 0",
                    filter: active ? 'drop-shadow(0 0 6px rgba(201,169,110,0.6))' : 'none',
                  }}
                >
                  {item.icon}
                </span>
                <span
                  className="text-[9px] font-semibold tracking-wider uppercase transition-colors duration-200"
                  style={{ color: active ? '#c9a96e' : 'rgba(255,255,255,0.3)' }}
                >
                  {item.label}
                </span>
                {/* Active dot */}
                {active && (
                  <span
                    className="absolute top-0.5 right-1/2 translate-x-1/2 w-1 h-1 rounded-full"
                    style={{ background: '#c9a96e' }}
                  />
                )}
              </button>
            );
          })}
        </div>
      </nav>
    </>
  );
};

export default MobileNav;
